import PayslipDownload from "../../../../components/company/pay-slip/employee-payslips/salary-disclaimer";



export default function PayslipDownloadPage(){
    return <PayslipDownload />
}